import { PageTilteProps } from '../../type'
import './index.css'

const PageTitle = ({
    pageTitle,
    pageDescription,
    pageBody,
}: PageTilteProps) => {
    return (
        <div className="page-head-info page-head-info-login">
            <h1>{pageTitle}</h1>
            <small className="short-info">{pageDescription}</small>
            {pageBody && <div>{pageBody}</div>}
        </div>
    )
}
export default PageTitle
